import ApplicationsPage from "@e50/components/HowToNominate/components/ApplicationsPage";
import DeclarationsPage from "@e50/components/HowToNominate/components/DeclarationsPage";
import EligibilityPage from "@e50/components/HowToNominate/components/EligibilityPage";
import RulesPage from "@e50/components/HowToNominate/components/RulesPage";
import { TabType } from "@hooks/useTabs";

/**
 * Returns the corresponding static component to render based on the provided active tab identifier.
 *
 * This function is typically used to dynamically render different sections of the
 * E50 How to Nominate page.
 *
 * @param page - The string identifier of the active tab (e.g., "nominations", "eligibility", "selections").
 * @returns The React component corresponding to the given page, or `undefined` if not matched.
 */
export const HowToNominateTabsFactory = (tab: TabType) => {
  switch (tab) {
    case "applicationsTab":
      return ApplicationsPage;

    case "eligibilityTab":
      return EligibilityPage;

    case "declarationsTab":
      return DeclarationsPage;

    case "rulesTab":
      return RulesPage;
  }
};
